import { getUserAgentParser } from './getUserAgentParser';

/**
 * Проверяет, запущено ли приложение как PWA на iOS (standalone-режим Safari).
 * Используется для обхода ограничений iOS PWA при скачивании файлов.
 *
 * Намеренно НЕ проверяет платформу (detectPlatform), потому что платформа
 * определяется по идентичности пользователя (tg_id/max_id в cookie),
 * а не по контексту рендеринга. Telegram/MAX WebView фильтруются в
 * downloadFile.js через isTelegramWebView() / isMaxWebView() до вызова этой функции.
 */
export const isIOSPWA = () => {
    const parser = getUserAgentParser()?.getOS();
    const isIOS = parser?.name === 'iOS';

    return isIOS && window.navigator.standalone === true;
};
